
<template>
  <div class="apply-rule notice light">
    <div class="layout-content">
      <SubTitle class="title" :text="data.title" />
      <div class="main section">
        <p class="main-title">{{data.descTitle}}</p>
        <ul class="main-title-list">

          <li class="main-row" v-for="(item, i) in data.list" :key="i">
            <img
              class="main-row-img"
              :src="item.img"
              v-if="!isMobile"
            >
            <span class="dot" v-else></span>
            <span class="main-text">{{item.text}}</span>
          </li>

          <p class="main-warn">{{data.warn}}</p>

          <div class="main-group">
            <div class="main-group-wrapper" v-if="!isMobile">
              <!-- <div class="main-group-qq">
                <img class="main-group-qq-img" :src="data.group.qq.qqImg" alt="">
                <p class="main-group-qq-text">{{data.group.qq.qqText}}</p>
              </div> -->

              <div class="main-group-wx">
                <div class="main-group-wx-content">
                  <div v-for="(item, index) in data.group.wx.list" :key="index">
                    <img class="main-group-wx-img" :src="item.img" alt="">
                  </div>
                </div>
                <p class="main-group-wx-wx-group">{{data.group.wx.wxText}}</p>
              </div>
            </div>

            <!-- 移动端 -->
            <div v-else>
              <!-- <div class="each-qrcode-section">
                <p class="qrcode-title">大赛交流QQ群</p>
                <img class="qrcode" src="../../assets/img/rules/QQ.png">
              </div> -->
              <div class="each-qrcode-section">
                <p class="qrcode-title">添加小助手进入微信群</p>
                <div class="img-wrapper">
                  <img class="qrcode" src="https://static001.geekbang.org/resource/image/ca/6d/ca83203e697e513f8171ddf7fb9f2b6d.png">
                  <img class="qrcode" src="https://static001.geekbang.org/resource/image/e5/06/e5874bbe2f2e849fc1yycee37d816506.png">
                  <img class="qrcode" src="https://static001.geekbang.org/resource/image/e4/7a/e4b2427556b163a3618c9fc1ecd2077a.png">
                </div>
              </div>
            </div>

            <div class="main-group-email">
              <img class="main-group-email-img" :src="data.group.email.emailImg" alt="">
              <p class="main-group-email-text">{{data.group.email.emailText}}</p>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubTitle from '@/components/SubTitle'

export default {
  props: ['data'],
  data () {
    return {

    }
  },
  components: {
    SubTitle
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
  }
}
</script>

<style lang="scss" scoped>
.apply-rule {
  padding-top: 80px;
  background: #F7F8FA;

  @include mobile {
    padding-bottom: 50px !important;
  }
}

.notice {
  padding-bottom: 120px;
}

.main {
  padding: 70px 90px 63px;
  @include font(17, 400);
  background: #FFFFFF;

  @include mobile {
    padding: 0;
    background: transparent;
  }
}

.main-row-img {
  display: inline-block;
  width: 18px; height: 18px;
  margin: 6px 19px 0 0;
}

.dot {
  flex: none;
  display: block;
  margin-top: 5px;
  margin-right: 17px;
  width: 6px; height: 6px;
  background: #1C72FF;
}

.main-title {
  margin-bottom: 36px;
  color: #000000;
  line-height: 35px;
  font-size: 20px; font-weight: 600;

  @include mobile {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 24px;
  }
}

.main-row {
  // position: relative;
  display: flex;
  margin-bottom: 36px;
  color: #828A92;
  line-height: 28px;
  font-size: 14px; font-weight: 400;

  @include mobile {
    display: flex;
    margin-bottom: 18px;
  }
}

.main-text {
  color: #000000;
  line-height: 30px;
  font-size: 16px; font-weight: 400;
  @include mobile {
    font-size: 13px;
    line-height: 22px;
  }
}

.main-warn {
  margin: 36px 0 60px;
  color: #828A92;
  line-height: 30px;
  font-size: 16px; font-weight: 400;

  @include mobile {
    margin: 20px 0 0;
    font-size: 12px;
    line-height: 20px;
  }
}

.main-group {
  display: flex;
  flex-direction: column;
  margin-top: 60px;

  @include mobile {
    margin-top: 0;
  }
}

.main-group-wrapper {
  display: flex;
  justify-content: center;
}

// .main-group-qq {
//   box-sizing: border-box;
//   width: 200px; height: 236px;
//   padding: 30px 30px 20px;
//   margin-right: 64px;
//   background: #E7F2FF;
// }

// .main-group-qq-img {
//   width: 140px; height: 140px;
//   margin: 0 auto;
// }

// .main-group-qq-text {
//   margin-top: 20px;
//   text-align: center;
//   font-size: 16px; font-weight: 500;
//   color: #000000;
//   line-height: 22px;
// }

.main-group-wx {
  display: flex; flex-direction: column;
  width: 100%;
  padding: 40px 128px 26px;
  text-align: center;
  background: #F2EDFF;
}

.main-group-wx-content {
  display: flex; justify-content: space-between;
}

.main-group-wx-img {
  width: 165px; height: 140px;
}

.main-group-wx-text {
  color: #828A92;
  line-height: 20px;
  font-size: 14px; font-weight: 400;
}

.main-group-wx-wx-group {
  margin-top: 28px;
  color: #000000;
  line-height: 22px;
  font-size: 16px; font-weight: 500;
}

.main-group-email {
  display: flex; justify-content: center; align-items: center;
  margin-top: 56px;

  @include mobile {
    justify-content: left;
    margin-top: 32px;
  }
}

.main-group-email-img {
  width: 38px; height: 30px;
  margin-right: 22px;

  @include mobile {
    width: 26px; height: auto;

  }
}

.main-group-email-text {
  color: #000000;
  line-height: 25px;
  font-size: 18px; font-weight: 500;
  font-family: Alibaba-PuHuiTi-Heavy;

  @include mobile {
    font-size: 14px;
  }
}

// 移动端二维码部分
.each-qrcode-section {
  margin-top: 30px;
}

.qrcode-title {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  line-height: 20px;
}

.img-wrapper {
 display: flex;
}

.qrcode {
  width: 100px;
  margin-right: 18px;

  &:last-child {
    margin-right: 0;
  }
}

</style>
